import { Controller } from '@hotwired/stimulus'
import { useTransition } from 'stimulus-use'
import * as dayjs from 'dayjs'
import weekdayDayjs from 'dayjs/plugin/weekday'
import devHelperDayjs from 'dayjs/plugin/devHelper'
import customParseFormatDayjs from 'dayjs/plugin/customParseFormat'
import 'dayjs/locale/ru'

dayjs.extend(customParseFormatDayjs)
dayjs.extend(devHelperDayjs)
dayjs.extend(weekdayDayjs)

dayjs.locale('ru')

export default class extends Controller {

    static targets = [
        'days',
        'title',
    ]

    static values = {
        today: String,
        month: String,
    }

    months = [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Днкабрь',
    ]

    days = [
        'пн',
        'вт',
        'ср',
        'чт',
        'пт',
        'сб',
        'вс',
    ]

    events = []

    get today() {
        return dayjs(this.todayValue, 'YYYY-MM-DD')
    }

    get month() {
        return dayjs(this.monthValue, 'YYYY-MM')
    }

    async connect() {
        await this.loadEvents()

        this.makeCalendar()
    }

    monthValueChanged() {
        this.updTitle()
        this.makeCalendar()
    }

    updTitle() {
        const string = this.month.format('MMMM YYYY')

        this.titleTarget.textContent = string[0].toUpperCase() + string.slice(1);
    }

    makeCalendar() {
        this.daysTarget.innerHTML = ''

        for (let index = 1; index <= this.month.startOf('M').weekday(); index++) {
            this.daysTarget.insertAdjacentHTML('beforeEnd', '<div></div>')
        }

        for (let index = 1; index <= this.month.daysInMonth(); index++) {
            const day = this.month.date(index)
            const isPast = this.isPast(day);
            const { hasEvent, eventIndex } = this.getEvent(day);

            let html = this.templateDayFeature({ day: index })

            if (isPast) {
                html = this.templateDayPast({ day: index })
            }

            if (hasEvent) {
                html = this.templateDayEvent({ day: index, eventIndex })
            }

            if (hasEvent && isPast) {
                html = this.templateDayPastEvent({ day: index, eventIndex })
            }

            this.daysTarget.insertAdjacentHTML('beforeEnd', html)
        }
    }

    getEvent(day) {
        let hasEvent = false, eventIndex = null

        this.events.forEach((element, index) => {
            if (this.isDate(day, dayjs(element.held_from))) {
                hasEvent = true
                eventIndex = index
            }
        });

        return { hasEvent, eventIndex }
    }

    isDate(day, eventDay) {
        if (day.diff(eventDay, 'year') !== 0) {
            return false
        }

        if (day.diff(eventDay, 'month') !== 0) {
            return false
        }

        if (day.diff(eventDay, 'day') !== 0) {
            return false
        }

        return true
    }

    isPast(day) {
        if (day.diff(this.today, 'year') < 0) {
            return true
        }

        if (day.diff(this.today, 'month') < 0) {
            return true
        }

        if (day.diff(this.today, 'day') < 0) {
            return true
        }

        return false
    }

    templateDayPast({ day }) {
        return `<button disabled class="w-[47px] h-[47px] mobile:w-[36px] mobile:h-[36px] flex justify-center items-center">`
            + `<span class="text-base text-silent-hill font-roboto">${day}</span>`
            + `</button>`;
    }

    templateDayFeature({ day }) {
        return `<button disabled class="w-[47px] h-[47px] mobile:w-[36px] mobile:h-[36px] flex justify-center items-center">`
            + `<span class="text-base text-50-shades-of-grey font-roboto">${day}</span>`
            + `</button>`;
    }

    templateDayEvent({ day, eventIndex }) {
        return `<button class="w-[47px] h-[47px] mobile:w-[36px] mobile:h-[36px] flex justify-center items-center rounded-full bg-neon-red" data-${this.identifier}-action="${this.identifier}#showEvent" data-${this.identifier}-event-param="${eventIndex}">`
            + `<span class="text-base text-la-cocaina font-roboto">${day}</span>`
            + `</button>`;
    }

    templateDayPastEvent({ day, eventIndex }) {
        return `<button class="w-[47px] h-[47px] mobile:w-[36px] mobile:h-[36px] flex justify-center items-center rounded-full bg-silent-hill" data-${this.identifier}-action="${this.identifier}#showEvent" data-${this.identifier}-event-param="${eventIndex}">`
            + `<span class="text-base text-la-cocaina font-roboto">${day}</span>`
            + `</button>`;
    }

    pastMonth() {
        this.monthValue = this.month.subtract(1, 'month').format('YYYY-MM')
    }

    nextMonth() {
        this.monthValue = this.month.add(1, 'month').format('YYYY-MM')
    }

    async loadEvents() {
        const res = await fetch('/events/calendar');
        const data = await res.json()

        this.events = data.events
    }
}